import { Mark } from "../Logo";

/** The agent's mark: the Flashadz mark, sending out a wave while the agent works. */
export function Orb({ live = true }: { live?: boolean }) {
  return <Mark className="orb" live={live} />;
}
